<template>
  <q-page class="sign-in-gate column no-wrap items-center justify-center">
    <div class="sign-in-card column no-wrap">
      <p class="sign-in-kicker">CTF Workflow</p>
      <h1 class="sign-in-title">Sign in to continue</h1>
      <p class="sign-in-copy">
        GitLab SSO is required. This board is not public.
      </p>
      <q-btn
        v-if="methods.oauth"
        unelevated
        no-caps
        color="primary"
        icon="login"
        label="Sign in with GitLab"
        class="self-start"
        @click="startSso"
      />
      <p v-else class="sign-in-copy">
        GitLab SSO is not configured on this host. Set GITLAB_OAUTH_CLIENT_ID
        and GITLAB_OAUTH_CLIENT_SECRET, then restart.
      </p>
    </div>
  </q-page>
</template>

<script lang="ts" setup>
import { useCurrentUser } from "@/composables/useCurrentUser";

const { methods } = useCurrentUser();

function startSso() {
  window.location.href = "/api/auth/gitlab/start";
}
</script>

<style lang="sass" scoped>
.sign-in-gate
  background: var(--bg-0)

.sign-in-card
  width: min(420px, calc(100% - 48px))
  padding: 32px
  background: var(--bg-1)
  border: 1px solid var(--border)
  border-radius: var(--radius)
  gap: 12px

.sign-in-kicker
  margin: 0
  font-size: 12px
  font-weight: 700
  letter-spacing: 0.04em
  text-transform: uppercase
  color: var(--text-muted)

.sign-in-title
  margin: 0
  font-size: 22px
  font-weight: 700
  letter-spacing: -0.02em
  color: var(--text)

.sign-in-copy
  margin: 0
  font-size: 14px
  line-height: 1.45
  color: var(--text-soft)
</style>
